import { Card, FormControl, FormHelperText, FormLabel } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useHelperTextClasses } from '../BaseTextField';

export type ListContainedContainerProps = {
  hasError: boolean;
  helperText?: string | false;
  label?: string;
  children: React.ReactNode;
  fullPageMobileView?: boolean;
  flex?: boolean;
};

export const ListContainedContainer: React.FC<ListContainedContainerProps> = ({ flex = true, ...props }) => {
  const { classes, cx } = useListContainedContainerStyles();
  const { classes: helperTextClasses } = useHelperTextClasses({});

  return (
    <FormControl
      fullWidth
      error={props.hasError}
      className={cx(classes.root, {
        [classes.rootFullScreen]: props.fullPageMobileView,
      })}
    >
      {props.label && <FormLabel className={classes.label} focused={false}>{props.label}</FormLabel>}
      <Card
        variant="outlined"
        className={cx(classes.card, {
          [classes.cardFlex]: flex,
          [classes.cardFullScreen]: props.fullPageMobileView,
          [classes.cardError]: props.hasError,
        })}
      >
        {props.children}
      </Card>
      {props.helperText && (
        <FormHelperText className={helperTextClasses.root}>
          {props.helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

const useListContainedContainerStyles = makeStyles({ name: 'ListContainedContainer' })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '522px',
    minHeight: '522px',
    [theme.breakpoints.up('sm')]: {
      height: '522px',
    }
  },
  rootFullScreen: {
    height: '100%',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardFlex: {
    flex: 1,
  },
  cardFullScreen: {
    [theme.breakpoints.down('sm')]: {
      border: 'none',
      borderRadius: 0,
    }
  },
  label: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  cardError: {
    border: `2px solid ${theme.palette.error.main}`
  },
}));
